import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useLanguageUrl } from '../utils/languageUtils';
import { getImageUrl } from '../utils/imageUtils';

const Hero = () => {
  const { t } = useTranslation();
  const { getLanguageUrl } = useLanguageUrl();

  return (
    <section className="hero-grad overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 sm:py-20 grid gap-10 lg:grid-cols-2 items-center">
        <div>
          {/* Badge */}
          <div className="inline-flex items-center gap-2 rounded-full bg-white/80 px-3 py-1 text-xs text-slate-600 chip">
            <span>{t('hero.badge')}</span>
          </div>

          {/* Title */}
          <h1 className="text-[12vw] font-extrabold leading-none">
            <span className="block text-2xl mt-6 font-semibold text-slate-700">
                {t('hero.title')}
            </span>
            <div className="display-text mt-6 font-extrabold text-[3vw]">
                {t('hero.tagline').split('.').map((word, i) => (
                <span key={i}>
                    {i === 1 ? (
                    <span className="text-[#22d3ee]">{word}.</span>
                    ) : (
                    <span>{word}.</span>
                    )}
                </span>
                ))}
            </div>
          </h1>
          

          {/* Subtitle */}
          <p className="mt-5 text-lg text-slate-600 max-w-xl">
            {t('hero.subtitle')}
          </p>

          {/* CTA Buttons */}
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Link 
              to={getLanguageUrl('/request-placement')} 
              className="rounded-2xl px-6 py-3 text-sm font-semibold text-white glow"
              style={{ background: 'linear-gradient(90deg, #06b6d4, #3b82f6, #6366f1)' }}
            >
              {t('hero.cta_primary')}
            </Link>
            <button 
              onClick={() => document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' })}
              className="rounded-2xl border px-6 py-3 text-sm font-semibold bg-white chip"
            >
              {t('hero.cta_secondary')}
            </button>
          </div>

          {/* Marquee */}
          <div className="mt-8 overflow-hidden">
            <div className="marquee whitespace-nowrap text-sm font-semibold text-slate-500">
              <span className="pr-8">
                {t('locations_marquee').split(' • ').map((location, index, array) => {
                  const locationMap = {
                    'OFFICES': '/offices',
                    'BUREAUX': '/offices',
                    'RESIDENTIAL': '/residential',
                    'RÉSIDENTIEL': '/residential',
                    'WAREHOUSES': '/warehouses',
                    'ENTREPÔTS': '/warehouses',
                    'HOTELS': '/hotels',
                    'HÔTELS': '/hotels',
                    'CAMPUSES': '/campuses',
                    'CAMPUS': '/campuses',
                    'HOSPITALS': '/hospitals',
                    'HÔPITAUX': '/hospitals',
                    'GYMS': '/gyms',
                    'GYMNASES': '/gyms'
                  };
                  return (
                    <span key={index}>
                      <Link 
                        to={locationMap[location] || `/${location.toLowerCase().replace(/\s+/g, '-')}`}
                        className="hover:text-brand-cyan transition-colors duration-200"
                      >
                        {location}
                      </Link>
                      {index < array.length - 1 && ' • '}
                    </span>
                  );
                })}
              </span>
              <span className="pr-8">
                {t('locations_marquee').split(' • ').map((location, index, array) => {
                  const locationMap = {
                    'OFFICES': '/offices',
                    'BUREAUX': '/offices',
                    'RESIDENTIAL': '/residential',
                    'RÉSIDENTIEL': '/residential',
                    'WAREHOUSES': '/warehouses',
                    'ENTREPÔTS': '/warehouses',
                    'HOTELS': '/hotels',
                    'HÔTELS': '/hotels',
                    'CAMPUSES': '/campuses',
                    'CAMPUS': '/campuses',
                    'HOSPITALS': '/hospitals',
                    'HÔPITAUX': '/hospitals',
                    'GYMS': '/gyms',
                    'GYMNASES': '/gyms'
                  };
                  return (
                    <span key={index}>
                      <Link 
                        to={locationMap[location] || `/${location.toLowerCase().replace(/\s+/g, '-')}`}
                        className="hover:text-brand-cyan transition-colors duration-200"
                      >
                        {location}
                      </Link>
                      {index < array.length - 1 && ' • '}
                    </span>
                  );
                })}
              </span>
            </div>
          </div>
        </div>

        {/* Hero Image */}
        <div className="relative">
          <div 
            className="absolute -inset-10 rounded-[3rem] blur-3xl opacity-50"
            style={{ 
              background: 'conic-gradient(from 90deg at 50% 50%, rgba(6,182,212,.2), rgba(99,102,241,.25), rgba(59,130,246,.2), transparent)' 
            }}
          />
          <img 
            src={getImageUrl("/images/smart-store.png")} 
            alt="Three Tap'nGrab smart coolers displaying snacks, beverages, and personal care products" 
            className="relative w-full h-auto rounded-[2rem] chip"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
